import { Box } from "@mui/material"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"

import PaymentTermRowActions from "../components/PaymentTermRowActions"

import StyledChip from "@/components/common/Chip/Chip"
import type { PaymentTerm } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"

export const usePaymentTermColumns = (): ColumnDef<PaymentTerm>[] => {
  const renderGreenCheckIcon = (
    <Box className='flex justify-center'>
      <CheckCircleFilledRounded className='text-tertiary-green-500' />
    </Box>
  )

  return [
    {
      accessorKey: "name",
      header: "Payment Term Name",
      enableSorting: true,
      size: 420,
    },
    {
      accessorKey: "payRunSchedule",
      header: () => <Box className='flex w-full justify-center'>Payrun Schedule</Box>,
      cell: ({ row }) => {
        const paymentTerm = row.original

        if (!paymentTerm.payRunSchedule) {
          return ""
        }
        return renderGreenCheckIcon
      },
      size: 170,
      enableSorting: false,
    },
    {
      accessorKey: "discounted",
      header: () => <Box className='flex w-full justify-center'>Discounted</Box>,
      cell: ({ row }) => {
        const paymentTerm = row.original

        const hasDiscount = paymentTerm.options.some((option) => option.parts.some((part) => part.discount))

        if (!hasDiscount) {
          return ""
        }
        return renderGreenCheckIcon
      },
      size: 170,
      enableSorting: false,
    },
    {
      accessorKey: "CreatedOn",
      header: "Created",
      cell: ({ row }) => {
        const classification = row.original
        return (
          <StyledChip
            label={<span>{formatDate(classification.createdOn)}</span>}
            classes={{
              colorDefault: "bg-gray-100",
            }}
            className='text-gray-900'
          />
        )
      },
      size: 120,
      enableSorting: true,
    },
    {
      accessorKey: "UpdatedOn",
      header: "Updated",
      cell: ({ row }) => {
        const classification = row.original
        return (
          <StyledChip
            label={<span>{formatDate(classification.updatedOn)}</span>}
            classes={{
              colorDefault: "bg-gray-100",
            }}
            className='text-gray-900'
          />
        )
      },
      size: 120,
      enableSorting: false,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => <PaymentTermRowActions paymentTerm={row.original} />,
      size: 50,
      enableSorting: false,
    },
  ]
}
